import ParallaxHeader from '../components/Parallaxheader';
import 'aos/dist/aos.css';
import AOS from 'aos';
import React, { useEffect, useState, useCallback } from 'react';
import CountUp from 'react-countup';
import { Target, CheckCheck, Award, Users, ChevronLeft, ChevronRight, X } from 'lucide-react';
import HallOfFame from './HallOfFame';

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // const images = [
  //   '/images/slideshowimage1.png',
  //   '/images/slideshowimage2.png',
  //   '/images/slideshowimage3.png',
  //   '/images/slideshowimage4.png',
  //   '/images/slideshowimage5.png',
  //   '/images/slideshowimage6.png',
  // ];

  const trainers = [
    {
      name: 'Kalyanaraghavan V.S.',
      title: 'National Instructor',
      year: 2019,
      certificateValidity: '2019-2020',
      certificateImage: '/images/Kalyanaraghavan.jpeg',
      badgeImage: '/images/Kalyanaraghavan.jpeg',
      description: 'FIDE Certified National Instructor with expertise in competitive chess training and strategy development.',
    },
    {
      name: 'Sivarajan V',
      fideId: '25645650',
      title: 'National Instructor',
      year: 2025,
      certificateValidity: '2025-2026',
      certificateImage: '/images/Sivarajan_25645650_sivarajanv_NI_20251120091157_page-0001.jpg',
      badgeImage: '/images/Sivarajan_25645650_sivarajanv_NI_20251120091157_page-0001.jpg',
      description: 'FIDE Certified National Instructor specializing in competitive chess training and strategy development.',
    },
    {
      name: 'Veera Raghavan S',
      fideId: '88189090',
      title: 'Developmental Instructor',
      year: 2025,
      certificateValidity: '2025-2026',
      certificateImage: '/images/Veera_88189090_Fide1_page-0001.jpg',
      badgeImage: '/images/Veera_88189090_Fide1_page-0001.jpg',
      description: 'FIDE Certified Developmental Instructor focused on nurturing young talents and beginner-level coaching.',
    },
    {
      name: 'Vishnu Priya P S',
      fideId: '25684264',
      title: 'National Instructor',
      year: 2025,
      certificateValidity: '2025-2026',
      certificateImage: '/images/vishnupriya_25684264_vishnupriyaps_NI_20251119031117_page-0001.jpg',
      badgeImage: '/images/vishnupriya_25684264_vishnupriyaps_NI_20251119031117_page-0001.jpg',
      description: 'FIDE Certified National Instructor with expertise in advanced chess techniques and tournament preparation.',
    }, {
      name: 'Govindarajan B',
      fideId: '531095500',
      title: 'Developmental Instructor',
      year: 2025,
      certificateValidity: '2026-2027',
      certificateImage: '/images/govindaraja_531095500_govindarajanb_DI_20251205061256_page-0001.jpg',
      badgeImage: '/images/govindaraja_531095500_govindarajanb_DI_20251205061256_page-0001.jpg',
      description: 'FIDE Certified Developmental Instructor passionate about building strong chess foundations and nurturing young talents at the grassroots level.',
    },
    {
      name: 'Eswari M.',
      fideId: 'C102032025',
      title: 'Level 1 Coach (Beginners)',
      year: 2025,
      certificateValidity: '2025-2026',
      certificateImage: '/images/Eswari M - Chengalpattu_page-0001.jpg',
      badgeImage: '/images/Eswari M - Chengalpattu_page-0001.jpg',
      description: 'Certified Level 1 Coach specializing in beginner chess education and fundamental skill development.',
    },
    {
      name: 'Rajendran C.',
      fideId: 'C108032026',
      title: 'Level 1 Coach (Beginners)',
      year: 2026,
      certificateValidity: '2026-2027',
      certificateImage: '/images/Rajendran C - Chengalpattu_page-0001.jpg',
      badgeImage: '/images/Rajendran C - Chengalpattu_page-0001.jpg',
      description: 'Certified Level 1 Coach dedicated to teaching chess fundamentals and nurturing beginner-level players.',
    },
  ];

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentCertificate, setCurrentCertificate] = useState(null);
  const [currentTrainerIndex, setCurrentTrainerIndex] = useState(0);
  const [isCarouselOpen, setIsCarouselOpen] = useState(false);

  const openLightbox = useCallback((trainer) => {
    setCurrentCertificate({
      src: trainer.certificateImage,
      name: trainer.name,
      title: trainer.title,
    });
    setLightboxOpen(true);
  }, []);

  const closeLightbox = useCallback(() => {
    setLightboxOpen(false);
    setCurrentCertificate(null);
  }, []);

  const openCarousel = useCallback((index) => {
    setCurrentTrainerIndex(index);
    setIsCarouselOpen(true);
  }, []);

  const nextTrainer = useCallback(() => {
    setCurrentTrainerIndex((prev) => (prev + 1) % trainers.length);
  }, [trainers.length]);

  const prevTrainer = useCallback(() => {
    setCurrentTrainerIndex((prev) => (prev - 1 + trainers.length) % trainers.length);
  }, [trainers.length]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (lightboxOpen && e.key === 'Escape') closeLightbox();
      if (isCarouselOpen && e.key === 'Escape') setIsCarouselOpen(false);
      if (isCarouselOpen && e.key === 'ArrowRight') nextTrainer();
      if (isCarouselOpen && e.key === 'ArrowLeft') prevTrainer();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen, isCarouselOpen, closeLightbox, nextTrainer, prevTrainer]);

  // Trainer Card Component to avoid repetition
  const TrainerCard = ({ trainer, index, onClickCertificate }) => (
    <div
      data-aos="fade-up"
      data-aos-delay={(index % 4) * 100}
      className="group bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 flex flex-col h-full"
    >
      <div
        className="relative bg-gradient-to-br from-gray-900 to-gray-800 p-5 cursor-pointer flex-shrink-0"
        onClick={() => openLightbox(trainer)}
      >
        <div className="flex items-center justify-between mb-3">
          <Award className="text-yellow-500 w-7 h-7" />
          <span className="text-xs text-yellow-500 bg-yellow-500/10 px-2 py-1 rounded-full">FIDE Certified</span>
        </div>
        <div className="text-center">
          <h3 className="text-lg font-bold text-white mb-1 line-clamp-2">{trainer.name}</h3>
          <p className="text-yellow-500 font-medium text-sm mb-1">{trainer.title}</p>
          {trainer.fideId && (
            <p className="text-gray-400 text-xs">FIDE ID: {trainer.fideId}</p>
          )}
        </div>
        <div className="mt-3 flex justify-center">
          <div className="w-20 h-14 bg-white/5 rounded-lg flex items-center justify-center border border-white/10">
            <span className="text-[10px] text-gray-400 text-center">FIDE<br />Cert.</span>
          </div>
        </div>
        <div className="absolute bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="text-[10px] text-yellow-500">Click to view →</span>
        </div>
      </div>

      <div className="p-5 flex flex-col flex-grow">
        <p className="text-gray-600 text-sm mb-4 leading-relaxed flex-grow">
          {trainer.description}
        </p>
        <div className="flex items-center justify-between pt-3 border-t border-gray-100 mt-auto">
          <div className="flex items-center gap-1.5">
            <Users className="w-3.5 h-3.5 text-yellow-600" />
            <span className="text-xs text-gray-500">FIDE Certified</span>
          </div>
          <button
            onClick={() => onClickCertificate(index)}
            className="text-yellow-600 hover:text-yellow-700 text-xs font-medium flex items-center gap-1 transition-colors"
          >
            View Certificate
            <ChevronRight className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <ParallaxHeader
        title="About Our Chess Club"
        breadcrumbs={[{ title: 'About Us', path: '/about' }]}
        backgroundImage="/images/aboutheader.jpg"
      />

      <section className="w-full bg-white py-16 px-6 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="w-full h-full flex items-center justify-center">
            <img
              src="/images/about/aboutintro.jpg"
              alt="About Chess"
              className="rounded-xl shadow-xl w-full object-cover max-h-[500px] lg:max-h-[600px]"
            />
          </div>
          <div data-aos="fade-left" className="flex flex-col justify-center h-full">
            <p className="text-yellow-600 text-sm uppercase font-medium mb-2">About Us</p>
            <h2 className="text-4xl lg:text-5xl font-serif font-bold text-gray-800 mb-4 leading-tight">
              We Are Best <br /> Chess Club <br /> Since 2015
            </h2>
            <p className="text-gray-600 text-base mb-8 leading-relaxed">
              We are a team of professional chess players dedicated to promoting chess learning at all levels.
              Our structured curriculum and coaching help you master the game, whether you're a beginner or an advanced player.
            </p>
            <div className="flex flex-wrap gap-10 items-center">
              <div>
                <h3 className="text-3xl font-bold text-gray-800">
                  <CountUp end={12} duration={2} />
                  <span className="text-yellow-600">+</span>
                </h3>
                <p className="text-gray-600">Years Experienced</p>
              </div>
              <div>
                <h3 className="text-3xl font-bold text-gray-800">
                  <CountUp end={800} duration={2} />
                  <span className="text-yellow-600">+</span>
                </h3>
                <p className="text-gray-600">Outstanding Members</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-br from-gray-50 to-white py-20 px-6 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12" data-aos="fade-up">
            <p className="text-yellow-600 text-sm uppercase font-medium mb-2 tracking-wider">Our Expert Team</p>
            <h2 className="text-4xl lg:text-5xl font-serif font-bold text-gray-800 mb-4">Certified FIDE Trainers</h2>
            <div className="w-24 h-1 bg-yellow-600 mx-auto mb-6"></div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Learn from internationally recognized FIDE-certified instructors who bring world-class chess education to your doorstep.
            </p>
          </div>

          {/* Responsive grid with auto-fit and consistent card sizes */}
          {/* 
            - Default: 1 column on mobile
            - sm (640px+): 2 columns
            - md (768px+): 3 columns  
            - lg (1024px+): 4 columns
            - xl (1280px+): 4 columns with max-width constraint
            The grid will automatically center the last row when there are fewer items
          */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {trainers.map((trainer, idx) => (
              <div key={idx} className="flex justify-center">
                <div className="w-full max-w-sm">
                  <TrainerCard 
                    trainer={trainer} 
                    index={idx} 
                    onClickCertificate={openCarousel}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center" data-aos="fade-up">
            <div className="inline-flex items-center gap-2 bg-yellow-50 border border-yellow-200 rounded-full px-6 py-3">
              <Award className="w-5 h-5 text-yellow-600" />
              <span className="text-gray-700 text-sm">
                All trainers are officially certified by the International Chess Federation (FIDE)
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-white py-20 px-6 lg:px-24">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-0 shadow-2xl">
          <div className="bg-black text-white p-10 flex flex-col items-center justify-center text-center">
            <Target className="w-12 h-12 text-yellow-500 mb-4 transition-transform duration-300 hover:scale-110" />
            <h3 className="text-2xl font-serif font-semibold mb-4">Our Vision</h3>
            <p className="text-gray-300 text-base leading-relaxed">
              To inspire strategic thinking and lifelong learning through chess, empowering students with confidence, patience, and decision-making skills.
            </p>
          </div>
          <div className="h-full w-full">
            <img src="/images/about/aboutmid.jpg" alt="Chess" className="h-full w-full object-cover rounded-none shadow-xl" />
          </div>
          <div className="bg-white text-gray-800 p-10 flex flex-col items-center justify-center text-center transition-transform duration-300 border">
            <CheckCheck className="w-12 h-12 text-yellow-500 mb-4 transition-transform duration-300 hover:scale-110" />
            <h3 className="text-2xl font-serif font-semibold mb-4">Our Mission</h3>
            <p className="text-gray-600 text-base leading-relaxed">
              To build a global community of chess enthusiasts and make high-quality chess education accessible to everyone, from beginners to advanced learners.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#f9f9f9]">
        <div className="container max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div data-aos="fade-right">
            <span className="text-[#a1860a] uppercase font-semibold text-sm mb-3 block">Why Choose Us</span>
            <h2 className="text-4xl font-serif font-bold text-gray-900 mb-6">Get The Best Coaching From Us</h2>
            <p className="text-gray-600 mb-8">
              Our programs are tailored to develop chess mastery at every level. Learn from expert coaches, win tournaments, and earn certifications.
            </p>
            {[
              { label: "Expert Coaches", value: 98 },
              { label: "Best Courses", value: 95 },
              { label: "Top Awards", value: 90 },
            ].map((item, index) => (
              <div key={index} className="mb-6">
                <div className="flex justify-between mb-1 text-sm font-medium text-gray-700">
                  <span>{item.label}</span>
                  <span>{item.value}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div className="bg-[#CEA82A] h-3 rounded-full transition-all duration-1000" style={{ width: `${item.value}%` }}></div>
                </div>
              </div>
            ))}
          </div>
          <div data-aos="fade-left">
            <img src="/images/chooseus.jpg" alt="Why Choose Us" className="rounded-lg shadow-lg" />
          </div>
        </div>
      </section>

      {/* <div className="mx-auto max-w-6xl py-10 px-3 lg:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {images.map((src, idx) => (
            <div key={idx} className="relative w-full overflow-hidden rounded-lg shadow" style={{ paddingBottom: '66.666%' }}>
              <img src={src} alt={`Gallery ${idx + 1}`} className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 hover:scale-105" />
            </div>
          ))}
        </div>
      </div> */}

      {/* Lightbox for certificate preview */}
      {lightboxOpen && currentCertificate && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm" onClick={closeLightbox}>
          <div className="relative max-w-4xl w-full mx-4 bg-white rounded-2xl overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <button onClick={closeLightbox} className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors">
              <X className="w-5 h-5" />
            </button>
            <div className="p-6 bg-gray-100 border-b">
              <h3 className="text-xl font-bold text-gray-800">{currentCertificate.name}</h3>
              <p className="text-yellow-600">{currentCertificate.title}</p>
            </div>
            <div className="p-6 flex justify-center bg-gray-50">
              <img src={currentCertificate.src} alt={`${currentCertificate.name} Certificate`} className="max-w-full max-h-[70vh] object-contain shadow-lg" onError={(e) => { e.currentTarget.src = 'https://via.placeholder.com/800x600?text=Certificate+Preview'; }} />
            </div>
          </div>
        </div>
      )}

      {/* Carousel for certificates */}
      {isCarouselOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm">
          <div className="relative max-w-5xl w-full mx-4">
            <button onClick={() => setIsCarouselOpen(false)} className="absolute -top-12 right-0 text-white hover:text-yellow-500 transition-colors">
              <X className="w-8 h-8" />
            </button>
            <button onClick={prevTrainer} className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors">
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button onClick={nextTrainer} className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors">
              <ChevronRight className="w-6 h-6" />
            </button>
            <div className="bg-white rounded-2xl overflow-hidden">
              <div className="p-6 bg-gray-100 border-b">
                <h3 className="text-2xl font-bold text-gray-800">{trainers[currentTrainerIndex].name}</h3>
                <p className="text-yellow-600 text-lg">{trainers[currentTrainerIndex].title}</p>
              </div>
              <div className="p-8 flex justify-center bg-gray-50">
                <img src={trainers[currentTrainerIndex].certificateImage} alt={`${trainers[currentTrainerIndex].name} Certificate`} className="max-w-full max-h-[65vh] object-contain shadow-lg" onError={(e) => { e.currentTarget.src = 'https://via.placeholder.com/1000x700?text=FIDE+Certificate'; }} />
              </div>
              <div className="p-4 bg-gray-100 flex justify-between items-center">
                <span className="text-xs text-gray-400">{currentTrainerIndex + 1} of {trainers.length}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CUSTOMIZED HALL OF FAME COMPONENT (11 Champions, Real Data)     */}
      <HallOfFame />
    </>
  );
};

export default About;